// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4Nryk4CZx{max-width:360px}._79BVz6Jgx{height:40px}\n", ""]);
// Exports
exports.locals = {
	"shell": "_4Nryk4CZx",
	"logo": "_79BVz6Jgx"
};
module.exports = exports;
